module.exports = __webpack_public_path__ + "img/5.aad13382.jpg";